import { render, staticRenderFns } from "./CourseGroupSelector.vue?vue&type=template&id=596cd343&scoped=true"
import script from "./CourseGroupSelector.vue?vue&type=script&lang=ts"
export * from "./CourseGroupSelector.vue?vue&type=script&lang=ts"
import style0 from "./CourseGroupSelector.vue?vue&type=style&index=0&id=596cd343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596cd343",
  null
  
)

export default component.exports